import { ComponentProps } from 'react'

import { useBreakpoints } from '@emico/ui'

import {
    Category as PrismicCategory,
    CategoryBodyTopBanner,
} from './graphql/schema.generated'
import PrismicImageOnly from './PrismicImageOnly'

interface HeaderProps {
    content: PrismicCategory | undefined
}

const PrismicCategoryTopBanner = ({ content }: HeaderProps) => {
    const { isDesktop } = useBreakpoints()

    const categoryBodyTopBannerContent = content?.body?.find(
        (slice) => slice.__typename === 'CategoryBodyTopBanner',
    ) as CategoryBodyTopBanner | undefined

    if (!categoryBodyTopBannerContent?.primary) {
        return null
    }

    const { image, mobileImage } = categoryBodyTopBannerContent.primary

    if (isDesktop && !image?.url) {
        return null
    }
    if (!isDesktop && !mobileImage?.url) {
        return null
    }

    const imageAlt = isDesktop ? image?.alt : mobileImage?.alt
    const imageUrl = image?.url ?? mobileImage?.url

    if (!imageUrl) {
        return null
    }

    const componentProps: ComponentProps<typeof PrismicImageOnly> = {
        style: 'light',
        image: imageUrl,
        imageMobile: mobileImage?.url ?? undefined,
        imageAlt: imageAlt ?? undefined,
    }

    return <PrismicImageOnly {...componentProps} />
}

export default PrismicCategoryTopBanner
